import React, { useEffect, useState } from "react";
import { Box, Button, Container, Grid, Modal, Typography } from "@mui/material";
import EvaluacionesMedicaItem from "./EvaluacionesMedicasItem";
import { getData } from "../../../services/library";
import EvaluacionesMedicasForm from "./EvaluacionesMedicasForm";
import { UrlApi } from "../../../services/apirest";

const EvaluacionesMedicas = ({
  id,
  mostrarAlertaTemporal,
  handleClose,
  open,
}) => {
  const [openEvaluacionesFormModal, setOpenEvaluacionesFormModal] =
    useState(false);
  const handleOpenFormModal = () => {
    setOpenEvaluacionesFormModal(true);
  };

  const rrhh = localStorage.getItem("adminrrhh");

  const marcarComoVisto = async (id) => {
    try {
      await fetch(`${UrlApi}/SP_candidatos/evaluacion/vista/${id}`, {
        method: "PUT",
      });
      console.log("Evaluación marcada como vista");
    } catch (error) {
      console.error("Error al actualizar la evaluación", error);
    }
  };

  useEffect(() => {
    if (rrhh === "1") {
      marcarComoVisto(id);
    }
  }, [id, rrhh]);

  const [evaluaciones, setEvaluaciones] = useState([]);

  const getEvaluaciones = () => {
    getData(`/SP_evaluaciones/${id}/${rrhh}`, setEvaluaciones);
  };

  useEffect(() => {
    getEvaluaciones();
  }, []);

  const sector = localStorage.getItem("sector");

  return (
    <>
      {openEvaluacionesFormModal && (
        <EvaluacionesMedicasForm
          idCandidato={id}
          isEditMode={false}
          onClose={() => setOpenEvaluacionesFormModal(false)}
          obtenerEvaluaciones={getEvaluaciones}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 1200,

            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 2,
            margin: "auto",
            overflowY: "auto",
          }}
        >
          {evaluaciones.length === 0 ? (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                No hay evaluaciones
              </Typography>
              {rrhh === "1" && (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2 }}
                  onClick={handleOpenFormModal}
                >
                  Agregar evaluacion medica
                </Button>
              )}
            </>
          ) : (
            <>
              <Typography variant="h6" id="modal-title" sx={{ mb: 2 }}>
                Evaluaciones medicas
              </Typography>
              {rrhh === "1" && (
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ mt: 2, mb: 2 }}
                  onClick={handleOpenFormModal}
                >
                  Agregar evaluacion medica
                </Button>
              )}

              <Box
                sx={{
                  margin: "auto",
                  display: "grid",
                  gap: 2,
                  gridTemplateColumns: "repeat(3, 1fr)",
                  maxHeight: 700,
                  overflow: "auto",
                  padding: 2,
                  border: "1px solid #ccc",
                  borderRadius: 1,
                }}
              >
                {evaluaciones.map((evaluacion) => (
                  <EvaluacionesMedicaItem
                    key={evaluacion.id}
                    id={evaluacion.id}
                    id_candidato={evaluacion.id_candidato}
                    prestador={evaluacion.prestador}
                    fecha={evaluacion.fecha}
                    aprobado_parte_rrhh={evaluacion.aprobado_parte_rrhh}
                    aprobado_parte_medico={evaluacion.aprobado_parte_medico}
                    uuid={evaluacion.uuid}
                    user={evaluacion.user}
                    username={evaluacion.username}
                    usersurname={evaluacion.usersurname}
                    nombre={evaluacion.nombre}
                    apellido={evaluacion.apellido}
                    mostrarAlertaTemporal={mostrarAlertaTemporal}
                    getEvaluaciones={getEvaluaciones}
                    total_archivos={evaluacion.total_archivos}
                  />
                ))}
              </Box>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default EvaluacionesMedicas;
